import { connect } from 'react-redux'
import { LKDate } from 'loankeeper-common/helpers/Date'
import createAction from 'loankeeper-common/helpers/createAction'

//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'

import { actions } from '../constants'
import { getShowCurrentGraphic } from '../selectors'

const mapStateToProps = (state, { ID }) => ({
  showCurrentGraphic: getShowCurrentGraphic(state, ID),
})

const mapDispatchToProps = (dispatch, { ID, hash }) => ({
  toggleShowOldGraphic: (showCurrentGraphic) => {
    dispatch(createAction(actions.TOGGLE_SHOW_OLD_GRAPHIC, { showCurrentGraphic }, { ID }))
  },

  openHistoryModal: (args) => {
    dispatch(LKModalActions.open(args))
  },

  getOldGraphicWithDate: ({ RestructureDate }) => {
    dispatch(
      createAction(
        actions.SWITCH_OLD_GRAPHIC,
        {
          RestrDate: LKDate.from(RestructureDate).toString(),
          hash,
        },
        {
          RestrDate: LKDate.from(RestructureDate).toString(),
          ID,
        },
      ),
    )
  },
})

export default connect(mapStateToProps, mapDispatchToProps)
